import { Injectable } from "@angular/core";
import{ Http, Headers } from "@angular/http";
import { map } from 'rxjs/operators';
import { GLOBAL } from './global';

@Injectable()
export class Seguimiento_exp_Service {
  [x: string]: any;
    
    public url;
    public identity;
    public token;
    constructor(private _http: Http){
        this.url = GLOBAL.url;
    }
    
    getSolicitudes(rut){
        let params = {
            rut: rut 
        };

        let headers = new Headers({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });

        return this._http.post(this.url+'seguimiento_expediente', params, {headers: headers})
        .pipe(map(res => res.json()));
    }

   /* getRut(rut, departamento){
        let params = {
            rut: rut, 
            departamento:departamento
           
        };

        let headers = new Headers({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });

        return this._http.post(this.url+'seguimiento_expediente', params, {headers: headers})
        .pipe(map(res => res.json()));
    }*/


    getExp(rut, numero, departamento){
        let params = {
            rut: rut, 
            numero:numero,
            departamento:departamento
           
        };

        let headers = new Headers({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });

        return this._http.post(this.url+'seguimiento_solicitud', params, {headers: headers})
        .pipe(map(res => res.json()));
    }

    getActa(exp){
        let params = {
            exp: exp
           
        };

        let headers = new Headers({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });

        return this._http.post(this.url+'acta_expediente', params, {headers: headers})
        .pipe(map(res => res.json()));
    }

   
}